import { Navigate, Route, Routes } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { TourPage } from './pages/TourPage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/es/recorrido" element={<TourPage language="es" />} />
      <Route path="/en/tour" element={<TourPage language="en" />} />
      <Route path="/es/gracias" element={<ThankYouPage language="es" />} />
      <Route path="/en/thank-you" element={<ThankYouPage language="en" />} />
      <Route path="/es" element={<Navigate to="/es/recorrido" replace />} />
      <Route path="/en" element={<Navigate to="/en/tour" replace />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
